require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./user-feedback-toasts-snackbars.json") })
        }
      }, "path---user-feedback-toasts-snackbars");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---user-feedback-toasts-snackbars!./.cache/json/user-feedback-toasts-snackbars.json
// module id = 417
// module chunks = 231608221292675